import { useQueryClient } from "@tanstack/vue-query";

import { queries } from "~/queries";

export default defineNuxtPlugin({
  name: "setInitialAuthState",
  parallel: true,
  dependsOn: ["amplify"],
  setup: async () => {
    const errorQuery = useAuthErrorQuery();

    if (errorQuery.value) {
      // right after a failed login attempt, trying to fetch the user crashes the app without throwing an error
      // probably something that happens internally within the amplify code
      return;
    }

    const queryClient = useQueryClient();
    await queryClient.fetchQuery(queries.amplifyAuth.isAuthenticated());
  },
});
